console.log("PREMIUM Configurator loading...");


// Hintamuutokset
const PRICE_ADJUSTMENTS = {
  euroAdjustment: 0,      // Euromääräinen lisäys/vähennys
  percentAdjustment: 0    // Prosentuaalinen lisäys/vähennys
};

// Määritä konfiguraatio
window.PremiumProductConfig = {
  variantIds: {
    base: 51829058535762,
    adjustment: 51813495931218
  },
  dimensions: {
    minWidth: 200,
    maxWidth: 1500,
    minHeight: 200,
    maxHeight: 2500,
    maxArea: 2.6,
  },
  profiles: {
    white9016: { name: "Valkoinen RAL9016", color: "#FFFFFF" },
    white9016structure: {
      name: "Valkoinen RAL9016 structure",
      color: "#F8F8F8",
    },
    white9010structure: {
      name: "Valkoinen RAL9010 structure",
      color: "#F1F1F1",
    },
    creme9001structure: { name: "Creme RAL9001 structure", color: "#F6F0E7" },
    beige1015: { name: "Beige RAL1015", color: "#EBCC90" },
    bronzeAnodized: { name: "Pronssi anodisoitu", color: "#8E7C67" },
    silverAnodized: { name: "Hopea anodisoitu E6/EV1", color: "#EDEDED" },
    lightGray7040: {
      name: "Vaaleanharmaa RAL7040 structure",
      color: "#C0C0C0",
    },
    darkGrayDB703: { name: "Tummanharmaa DB 703", color: "#575556" },
    anthracite7016: { name: "Antrasiitti RAL7016 structure", color: "#3C3C3C" },
    black9005structure: { name: "Musta RAL9005 structure", color: "#0A0A0A" },
  },
  priceTable: {
    S: {
      700: {
        400: 93,
        500: 98,
        600: 105,
        700: 121,
        800: 133,
        900: 147,
        1000: 158,
        1100: 168,
        1200: 184,
        1300: 195,
        1400: 205,
        1500: 218,
        1600: 229,
        1700: 242,
        1800: 252,
        1900: 264,
        2000: 275,
        2100: 286,
        2200: 302,
      },
      800: {
        400: 93,
        500: 100,
        600: 109,
        700: 124,
        800: 135,
        900: 152,
        1000: 161,
        1100: 172,
        1200: 188,
        1300: 200,
        1400: 210,
        1500: 223,
        1600: 235,
        1700: 248,
        1800: 259,
        1900: 269,
        2000: 282,
        2100: 293,
        2200: 309,
      },
      900: {
        400: 96,
        500: 103,
        600: 112,
        700: 130,
        800: 141,
        900: 157,
        1000: 168,
        1100: 176,
        1200: 195,
        1300: 207,
        1400: 219,
        1500: 233,
        1600: 244,
        1700: 259,
        1800: 269,
        1900: 281,
        2000: 295,
        2100: 305,
        2200: 322,
      },
      1000: {
        400: 99,
        500: 107,
        600: 117,
        700: 134,
        800: 147,
        900: 163,
        1000: 174,
        1100: 185,
        1200: 202,
        1300: 215,
        1400: 226,
        1500: 241,
        1600: 253,
        1700: 268,
        1800: 281,
        1900: 293,
        2000: 306,
        2100: 318,
        2200: 335,
      },
      1100: {
        400: 103,
        500: 111,
        600: 121,
        700: 138,
        800: 151,
        900: 169,
        1000: 180,
        1100: 192,
        1200: 211,
        1300: 222,
        1400: 236,
        1500: 250,
        1600: 263,
        1700: 279,
        1800: 291,
        1900: 304,
        2000: 317,
        2100: 331,
        2200: 347,
      },
      1200: {
        400: 106,
        500: 114,
        600: 125,
        700: 144,
        800: 156,
        900: 173,
        1000: 186,
        1100: 198,
        1200: 218,
        1300: 231,
        1400: 245,
        1500: 259,
        1600: 272,
        1700: 289,
        1800: 302,
        1900: 315,
        2000: 329,
        2100: 342,
        2200: 361,
      },
      1300: {
        400: 110,
        500: 118,
        600: 130,
        700: 148,
        800: 161,
        900: 179,
        1000: 192,
        1100: 207,
        1200: 225,
        1300: 239,
        1400: 252,
        1500: 268,
        1600: 283,
        1700: 299,
        1800: 312,
        1900: 327,
        2000: 341,
        2100: 355,
        2200: 374,
      },
      1400: {
        400: 112,
        500: 121,
        600: 134,
        700: 152,
        800: 167,
        900: 185,
        1000: 198,
        1100: 212,
        1200: 232,
        1300: 247,
        1400: 262,
        1500: 276,
        1600: 291,
        1700: 309,
        1800: 324,
        1900: 338,
        2000: 353,
        2100: 368,
        2200: 387,
      },
      1500: {
        400: 116,
        500: 125,
        600: 137,
        700: 157,
        800: 171,
        900: 191,
        1000: 205,
        1100: 220,
        1200: 240,
        1300: 254,
        1400: 270,
        1500: 286,
        1600: 302,
        1700: 320,
        1800: 334,
        1900: 349,
        2000: 365,
        2100: 381,
        2200: 400,
      },
      1600: {
        400: 119,
        500: 128,
        600: 143,
        700: 163,
        800: 177,
        900: 196,
        1000: 211,
        1100: 227,
        1200: 247,
        1300: 262,
        1400: 278,
        1500: 294,
        1600: 310,
        1700: 330,
        1800: 346,
        1900: 360,
        2000: 378,
        2100: 391,
        2200: 412,
      },
      1700: {
        400: 123,
        500: 132,
        600: 147,
        700: 168,
        800: 183,
        900: 202,
        1000: 218,
        1100: 233,
        1200: 253,
        1300: 270,
        1400: 286,
        1500: 303,
        1600: 321,
        1700: 340,
        1800: 356,
        1900: 371,
        2000: 388,
        2100: 404,
        2200: 425,
      },
      1800: {
        400: 126,
        500: 135,
        600: 150,
        700: 171,
        800: 188,
        900: 207,
        1000: 224,
        1100: 240,
        1200: 261,
        1300: 279,
        1400: 296,
        1500: 313,
        1600: 329,
        1700: 351,
        1800: 366,
        1900: 383,
        2000: 400,
        2100: 417,
        2200: 439,
      },
      1900: {
        400: 129,
        500: 139,
        600: 154,
        700: 177,
        800: 193,
        900: 212,
        1000: 228,
        1100: 247,
        1200: 269,
        1300: 286,
        1400: 303,
        1500: 321,
        1600: 340,
        1700: 360,
        1800: 377,
        1900: 395,
        2000: 412,
        2100: 429,
        2200: 452,
      },
      2000: {
        400: 132,
        500: 142,
        600: 160,
        700: 180,
        800: 199,
        900: 219,
        1000: 235,
        1100: 254,
        1200: 277,
        1300: 294,
        1400: 312,
        1500: 331,
        1600: 349,
        1700: 371,
        1800: 388,
        1900: 406,
        2000: 425,
        2100: 441,
        2200: 465,
      },
      2100: {
        400: 136,
        500: 146,
        600: 163,
        700: 185,
        800: 203,
        900: 224,
        1000: 241,
        1100: 260,
        1200: 283,
        1300: 301,
        1400: 319,
        1500: 339,
        1600: 357,
        1700: 380,
        1800: 399,
        1900: 417,
        2000: 435,
        2100: 454,
        2200: 477,
      },
      2200: {
        400: 139,
        500: 149,
        600: 168,
        700: 190,
        800: 208,
        900: 231,
        1000: 247,
        1100: 266,
        1200: 291,
        1300: 310,
        1400: 329,
        1500: 350,
        1600: 368,
        1700: 391,
        1800: 409,
        1900: 429,
        2000: 447,
        2100: 467,
        2200: 490,
      },
      2300: {
        400: 143,
        500: 154,
        600: 171,
        700: 196,
        800: 214,
        900: 236,
        1000: 254,
        1100: 274,
        1200: 298,
        1300: 318,
        1400: 337,
        1500: 358,
        1600: 376,
        1700: 402,
        1800: 421,
        1900: 441,
        2000: 459,
        2100: 479,
        2200: 503,
      },
      2400: {
        400: 145,
        500: 157,
        600: 176,
        700: 199,
        800: 220,
        900: 240,
        1000: 260,
        1100: 280,
        1200: 306,
        1300: 326,
        1400: 345,
        1500: 367,
        1600: 387,
        1700: 411,
        1800: 430,
        1900: 451,
        2000: 471,
        2100: 492,
        2200: 517,
      },
      2500: {
        400: 149,
        500: 160,
        600: 180,
        700: 204,
        800: 225,
        900: 248,
        1000: 267,
        1100: 287,
        1200: 312,
        1300: 333,
        1400: 354,
        1500: 376,
        1600: 395,
        1700: 422,
        1800: 442,
        1900: 463,
        2000: 483,
        2100: 503,
        2200: 530,
      },
      2600: {
        400: 152,
        500: 164,
        600: 184,
        700: 210,
        800: 230,
        900: 252,
        1000: 272,
        1100: 294,
        1200: 320,
        1300: 341,
        1400: 363,
        1500: 385,
        1600: 406,
        1700: 432,
        1800: 453,
        1900: 474,
        2000: 494,
        2100: 515,
        2200: 542,
      },
      2700: {
        400: 156,
        500: 167,
        600: 189,
        700: 213,
        800: 235,
        900: 258,
        1000: 278,
        1100: 301,
        1200: 328,
        1300: 349,
        1400: 370,
        1500: 394,
        1600: 415,
        1700: 442,
        1800: 463,
        1900: 484,
        2000: 507,
        2100: 528,
        2200: 555,
      },
      2800: {
        400: 159,
        500: 172,
        600: 193,
        700: 218,
        800: 240,
        900: 264,
        1000: 285,
        1100: 307,
        1200: 336,
        1300: 358,
        1400: 380,
        1500: 403,
        1600: 424,
        1700: 452,
        1800: 474,
        1900: 496,
        2000: 518,
        2100: 541,
        2200: 568,
      },
    },
    0: {
      700: {
        400: 99,
        500: 107,
        600: 116,
        700: 133,
        800: 143,
        900: 161,
        1000: 172,
        1100: 183,
        1200: 200,
        1300: 213,
        1400: 223,
        1500: 237,
        1600: 249,
        1700: 263,
        1800: 275,
        1900: 286,
        2000: 300,
        2100: 311,
        2200: 328,
      },
      800: {
        400: 103,
        500: 109,
        600: 118,
        700: 135,
        800: 148,
        900: 166,
        1000: 175,
        1100: 188,
        1200: 206,
        1300: 217,
        1400: 230,
        1500: 243,
        1600: 256,
        1700: 271,
        1800: 282,
        1900: 294,
        2000: 307,
        2100: 319,
        2200: 336,
      },
      900: {
        400: 105,
        500: 113,
        600: 122,
        700: 140,
        800: 154,
        900: 171,
        1000: 182,
        1100: 195,
        1200: 213,
        1300: 227,
        1400: 238,
        1500: 254,
        1600: 265,
        1700: 281,
        1800: 294,
        1900: 306,
        2000: 320,
        2100: 333,
        2200: 352,
      },
      1000: {
        400: 109,
        500: 116,
        600: 128,
        700: 146,
        800: 158,
        900: 177,
        1000: 189,
        1100: 203,
        1200: 223,
        1300: 235,
        1400: 247,
        1500: 262,
        1600: 276,
        1700: 293,
        1800: 307,
        1900: 319,
        2000: 334,
        2100: 346,
        2200: 366,
      },
      1100: {
        400: 112,
        500: 121,
        600: 132,
        700: 151,
        800: 166,
        900: 184,
        1000: 196,
        1100: 210,
        1200: 230,
        1300: 243,
        1400: 257,
        1500: 273,
        1600: 288,
        1700: 305,
        1800: 317,
        1900: 331,
        2000: 347,
        2100: 359,
        2200: 379,
      },
      1200: {
        400: 116,
        500: 125,
        600: 136,
        700: 157,
        800: 170,
        900: 190,
        1000: 204,
        1100: 217,
        1200: 237,
        1300: 251,
        1400: 266,
        1500: 283,
        1600: 297,
        1700: 315,
        1800: 329,
        1900: 344,
        2000: 360,
        2100: 374,
        2200: 394,
      },
      1300: {
        400: 121,
        500: 129,
        600: 142,
        700: 163,
        800: 176,
        900: 196,
        1000: 209,
        1100: 225,
        1200: 246,
        1300: 261,
        1400: 277,
        1500: 293,
        1600: 308,
        1700: 326,
        1800: 342,
        1900: 357,
        2000: 372,
        2100: 388,
        2200: 408,
      },
      1400: {
        400: 124,
        500: 133,
        600: 147,
        700: 167,
        800: 183,
        900: 203,
        1000: 218,
        1100: 233,
        1200: 253,
        1300: 269,
        1400: 285,
        1500: 303,
        1600: 319,
        1700: 338,
        1800: 354,
        1900: 369,
        2000: 386,
        2100: 402,
        2200: 423,
      },
      1500: {
        400: 128,
        500: 138,
        600: 151,
        700: 172,
        800: 188,
        900: 209,
        1000: 224,
        1100: 241,
        1200: 263,
        1300: 279,
        1400: 295,
        1500: 313,
        1600: 329,
        1700: 348,
        1800: 365,
        1900: 382,
        2000: 399,
        2100: 415,
        2200: 437,
      },
      1600: {
        400: 131,
        500: 141,
        600: 155,
        700: 178,
        800: 195,
        900: 216,
        1000: 231,
        1100: 248,
        1200: 271,
        1300: 287,
        1400: 304,
        1500: 322,
        1600: 340,
        1700: 360,
        1800: 377,
        1900: 395,
        2000: 412,
        2100: 429,
        2200: 452,
      },
      1700: {
        400: 136,
        500: 145,
        600: 161,
        700: 183,
        800: 200,
        900: 222,
        1000: 238,
        1100: 255,
        1200: 278,
        1300: 296,
        1400: 313,
        1500: 333,
        1600: 350,
        1700: 372,
        1800: 389,
        1900: 408,
        2000: 426,
        2100: 443,
        2200: 466,
      },
      1800: {
        400: 139,
        500: 148,
        600: 165,
        700: 187,
        800: 206,
        900: 228,
        1000: 244,
        1100: 262,
        1200: 287,
        1300: 305,
        1400: 323,
        1500: 342,
        1600: 361,
        1700: 384,
        1800: 401,
        1900: 419,
        2000: 438,
        2100: 456,
        2200: 480,
      },
      1900: {
        400: 142,
        500: 152,
        600: 169,
        700: 193,
        800: 213,
        900: 233,
        1000: 252,
        1100: 270,
        1200: 294,
        1300: 314,
        1400: 332,
        1500: 353,
        1600: 371,
        1700: 394,
        1800: 413,
        1900: 432,
        2000: 451,
        2100: 470,
        2200: 496,
      },
      2000: {
        400: 145,
        500: 157,
        600: 175,
        700: 198,
        800: 217,
        900: 239,
        1000: 256,
        1100: 277,
        1200: 304,
        1300: 323,
        1400: 342,
        1500: 362,
        1600: 382,
        1700: 406,
        1800: 426,
        1900: 445,
        2000: 465,
        2100: 483,
        2200: 509,
      },
      2100: {
        400: 149,
        500: 160,
        600: 180,
        700: 203,
        800: 223,
        900: 245,
        1000: 266,
        1100: 286,
        1200: 311,
        1300: 331,
        1400: 351,
        1500: 372,
        1600: 393,
        1700: 418,
        1800: 438,
        1900: 457,
        2000: 478,
        2100: 497,
        2200: 523,
      },
      2200: {
        400: 154,
        500: 164,
        600: 183,
        700: 210,
        800: 229,
        900: 252,
        1000: 272,
        1100: 293,
        1200: 318,
        1300: 340,
        1400: 361,
        1500: 383,
        1600: 403,
        1700: 429,
        1800: 448,
        1900: 469,
        2000: 491,
        2100: 512,
        2200: 538,
      },
      2300: {
        400: 157,
        500: 168,
        600: 189,
        700: 214,
        800: 235,
        900: 258,
        1000: 278,
        1100: 301,
        1200: 328,
        1300: 348,
        1400: 370,
        1500: 392,
        1600: 414,
        1700: 439,
        1800: 461,
        1900: 482,
        2000: 503,
        2100: 526,
        2200: 552,
      },
      2400: {
        400: 161,
        500: 173,
        600: 194,
        700: 219,
        800: 241,
        900: 265,
        1000: 286,
        1100: 308,
        1200: 336,
        1300: 358,
        1400: 380,
        1500: 403,
        1600: 423,
        1700: 451,
        1800: 473,
        1900: 495,
        2000: 517,
        2100: 539,
        2200: 566,
      },
      2500: {
        400: 164,
        500: 177,
        600: 198,
        700: 225,
        800: 247,
        900: 271,
        1000: 292,
        1100: 315,
        1200: 344,
        1300: 366,
        1400: 388,
        1500: 412,
        1600: 435,
        1700: 462,
        1800: 486,
        1900: 508,
        2000: 530,
        2100: 552,
        2200: 581,
      },
      2600: {
        400: 169,
        500: 180,
        600: 202,
        700: 230,
        800: 253,
        900: 277,
        1000: 300,
        1100: 323,
        1200: 352,
        1300: 375,
        1400: 398,
        1500: 421,
        1600: 446,
        1700: 473,
        1800: 497,
        1900: 521,
        2000: 543,
        2100: 566,
        2200: 596,
      },
      2700: {
        400: 172,
        500: 184,
        600: 208,
        700: 234,
        800: 258,
        900: 284,
        1000: 306,
        1100: 329,
        1200: 359,
        1300: 384,
        1400: 408,
        1500: 432,
        1600: 455,
        1700: 485,
        1800: 508,
        1900: 533,
        2000: 557,
        2100: 580,
        2200: 610,
      },
      2800: {
        400: 175,
        500: 188,
        600: 213,
        700: 239,
        800: 265,
        900: 290,
        1000: 312,
        1100: 336,
        1200: 369,
        1300: 393,
        1400: 417,
        1500: 443,
        1600: 467,
        1700: 497,
        1800: 521,
        1900: 546,
        2000: 570,
        2100: 594,
        2200: 624,
      },
    },
    1: {
      700: {
        400: 104,
        500: 112,
        600: 127,
        700: 140,
        800: 160,
        900: 180,
        1000: 193,
        1100: 206,
        1200: 223,
        1300: 236,
        1400: 250,
        1500: 265,
        1600: 278,
        1700: 293,
        1800: 312,
        1900: 327,
        2000: 340,
        2100: 355,
        2200: 368,
      },
      800: {
        400: 106,
        500: 115,
        600: 130,
        700: 145,
        800: 166,
        900: 185,
        1000: 200,
        1100: 214,
        1200: 228,
        1300: 243,
        1400: 257,
        1500: 272,
        1600: 288,
        1700: 302,
        1800: 323,
        1900: 337,
        2000: 351,
        2100: 365,
        2200: 379,
      },
      900: {
        400: 111,
        500: 121,
        600: 135,
        700: 151,
        800: 173,
        900: 193,
        1000: 208,
        1100: 224,
        1200: 240,
        1300: 255,
        1400: 270,
        1500: 286,
        1600: 302,
        1700: 317,
        1800: 338,
        1900: 353,
        2000: 368,
        2100: 384,
        2200: 400,
      },
      1000: {
        400: 116,
        500: 126,
        600: 142,
        700: 158,
        800: 181,
        900: 203,
        1000: 218,
        1100: 234,
        1200: 250,
        1300: 267,
        1400: 284,
        1500: 300,
        1600: 316,
        1700: 332,
        1800: 355,
        1900: 371,
        2000: 386,
        2100: 403,
        2200: 419,
      },
      1100: {
        400: 122,
        500: 131,
        600: 148,
        700: 165,
        800: 188,
        900: 210,
        1000: 226,
        1100: 244,
        1200: 261,
        1300: 279,
        1400: 297,
        1500: 314,
        1600: 330,
        1700: 347,
        1800: 371,
        1900: 387,
        2000: 404,
        2100: 421,
        2200: 439,
      },
      1200: {
        400: 126,
        500: 135,
        600: 154,
        700: 171,
        800: 196,
        900: 219,
        1000: 235,
        1100: 255,
        1200: 273,
        1300: 292,
        1400: 310,
        1500: 327,
        1600: 344,
        1700: 364,
        1800: 388,
        1900: 404,
        2000: 424,
        2100: 440,
        2200: 459,
      },
      1300: {
        400: 131,
        500: 141,
        600: 161,
        700: 179,
        800: 204,
        900: 226,
        1000: 244,
        1100: 264,
        1200: 284,
        1300: 302,
        1400: 322,
        1500: 340,
        1600: 360,
        1700: 379,
        1800: 403,
        1900: 423,
        2000: 441,
        2100: 460,
        2200: 479,
      },
      1400: {
        400: 137,
        500: 147,
        600: 165,
        700: 185,
        800: 213,
        900: 236,
        1000: 254,
        1100: 275,
        1200: 296,
        1300: 314,
        1400: 335,
        1500: 354,
        1600: 374,
        1700: 394,
        1800: 420,
        1900: 439,
        2000: 459,
        2100: 479,
        2200: 499,
      },
      1500: {
        400: 142,
        500: 152,
        600: 171,
        700: 193,
        800: 220,
        900: 244,
        1000: 263,
        1100: 286,
        1200: 306,
        1300: 327,
        1400: 349,
        1500: 368,
        1600: 388,
        1700: 410,
        1800: 436,
        1900: 456,
        2000: 477,
        2100: 496,
        2200: 518,
      },
      1600: {
        400: 146,
        500: 158,
        600: 178,
        700: 199,
        800: 228,
        900: 252,
        1000: 272,
        1100: 295,
        1200: 317,
        1300: 339,
        1400: 362,
        1500: 383,
        1600: 403,
        1700: 425,
        1800: 453,
        1900: 474,
        2000: 494,
        2100: 515,
        2200: 538,
      },
      1700: {
        400: 151,
        500: 162,
        600: 184,
        700: 205,
        800: 235,
        900: 261,
        1000: 281,
        1100: 306,
        1200: 329,
        1300: 351,
        1400: 375,
        1500: 396,
        1600: 417,
        1700: 440,
        1800: 469,
        1900: 490,
        2000: 512,
        2100: 534,
        2200: 557,
      },
      1800: {
        400: 156,
        500: 167,
        600: 191,
        700: 213,
        800: 242,
        900: 269,
        1000: 290,
        1100: 315,
        1200: 341,
        1300: 362,
        1400: 387,
        1500: 410,
        1600: 432,
        1700: 457,
        1800: 485,
        1900: 507,
        2000: 531,
        2100: 553,
        2200: 578,
      },
      1900: {
        400: 161,
        500: 174,
        600: 196,
        700: 219,
        800: 252,
        900: 277,
        1000: 300,
        1100: 326,
        1200: 352,
        1300: 374,
        1400: 400,
        1500: 423,
        1600: 447,
        1700: 472,
        1800: 501,
        1900: 524,
        2000: 549,
        2100: 573,
        2200: 597,
      },
      2000: {
        400: 165,
        500: 179,
        600: 202,
        700: 227,
        800: 260,
        900: 285,
        1000: 309,
        1100: 336,
        1200: 362,
        1300: 386,
        1400: 413,
        1500: 437,
        1600: 460,
        1700: 488,
        1800: 518,
        1900: 541,
        2000: 566,
        2100: 591,
        2200: 617,
      },
      2100: {
        400: 171,
        500: 184,
        600: 209,
        700: 233,
        800: 267,
        900: 294,
        1000: 318,
        1100: 346,
        1200: 374,
        1300: 398,
        1400: 427,
        1500: 451,
        1600: 474,
        1700: 503,
        1800: 534,
        1900: 558,
        2000: 584,
        2100: 609,
        2200: 637,
      },
      2200: {
        400: 176,
        500: 190,
        600: 215,
        700: 239,
        800: 274,
        900: 303,
        1000: 326,
        1100: 355,
        1200: 385,
        1300: 410,
        1400: 440,
        1500: 464,
        1600: 489,
        1700: 518,
        1800: 550,
        1900: 575,
        2000: 603,
        2100: 628,
        2200: 657,
      },
      2300: {
        400: 181,
        500: 194,
        600: 222,
        700: 247,
        800: 282,
        900: 310,
        1000: 336,
        1100: 366,
        1200: 396,
        1300: 423,
        1400: 451,
        1500: 478,
        1600: 503,
        1700: 534,
        1800: 566,
        1900: 592,
        2000: 621,
        2100: 647,
        2200: 677,
      },
      2400: {
        400: 187,
        500: 200,
        600: 227,
        700: 253,
        800: 291,
        900: 320,
        1000: 346,
        1100: 375,
        1200: 407,
        1300: 433,
        1400: 464,
        1500: 492,
        1600: 519,
        1700: 550,
        1800: 583,
        1900: 609,
        2000: 640,
        2100: 665,
        2200: 696,
      },
      2500: {
        400: 191,
        500: 206,
        600: 233,
        700: 260,
        800: 299,
        900: 328,
        1000: 355,
        1100: 386,
        1200: 418,
        1300: 446,
        1400: 477,
        1500: 505,
        1600: 533,
        1700: 565,
        1800: 599,
        1900: 626,
        2000: 657,
        2100: 684,
        2200: 716,
      },
      2600: {
        400: 196,
        500: 211,
        600: 240,
        700: 268,
        800: 306,
        900: 336,
        1000: 364,
        1100: 395,
        1200: 429,
        1300: 458,
        1400: 490,
        1500: 518,
        1600: 547,
        1700: 581,
        1800: 614,
        1900: 642,
        2000: 675,
        2100: 704,
        2200: 735,
      },
      2700: {
        400: 201,
        500: 216,
        600: 246,
        700: 275,
        800: 314,
        900: 345,
        1000: 372,
        1100: 406,
        1200: 441,
        1300: 470,
        1400: 505,
        1500: 532,
        1600: 562,
        1700: 596,
        1800: 631,
        1900: 660,
        2000: 693,
        2100: 723,
        2200: 756,
      },
      2800: {
        400: 205,
        500: 221,
        600: 252,
        700: 282,
        800: 321,
        900: 353,
        1000: 382,
        1100: 417,
        1200: 453,
        1300: 482,
        1400: 515,
        1500: 546,
        1600: 577,
        1700: 611,
        1800: 647,
        1900: 676,
        2000: 710,
        2100: 740,
        2200: 776,
      },
    },
    2: {
      700: {
        400: 113,
        500: 124,
        600: 136,
        700: 157,
        800: 176,
        900: 196,
        1000: 214,
        1100: 229,
        1200: 248,
        1300: 263,
        1400: 283,
        1500: 298,
        1600: 317,
        1700: 331,
        1800: 350,
        1900: 365,
        2000: 384,
        2100: 398,
        2200: 418,
      },
      800: {
        400: 118,
        500: 127,
        600: 142,
        700: 163,
        800: 182,
        900: 203,
        1000: 222,
        1100: 237,
        1200: 258,
        1300: 272,
        1400: 293,
        1500: 307,
        1600: 328,
        1700: 343,
        1800: 363,
        1900: 378,
        2000: 398,
        2100: 413,
        2200: 433,
      },
      900: {
        400: 124,
        500: 133,
        600: 149,
        700: 171,
        800: 191,
        900: 215,
        1000: 235,
        1100: 250,
        1200: 272,
        1300: 287,
        1400: 310,
        1500: 325,
        1600: 348,
        1700: 363,
        1800: 383,
        1900: 400,
        2000: 420,
        2100: 436,
        2200: 459,
      },
      1000: {
        400: 130,
        500: 140,
        600: 158,
        700: 180,
        800: 202,
        900: 225,
        1000: 246,
        1100: 263,
        1200: 287,
        1300: 303,
        1400: 326,
        1500: 342,
        1600: 367,
        1700: 384,
        1800: 406,
        1900: 423,
        2000: 445,
        2100: 462,
        2200: 486,
      },
      1000: {
        400: 137,
        500: 147,
        600: 165,
        700: 188,
        800: 213,
        900: 237,
        1000: 259,
        1100: 276,
        1200: 300,
        1300: 319,
        1400: 343,
        1500: 361,
        1600: 386,
        1700: 404,
        1800: 427,
        1900: 445,
        2000: 467,
        2100: 486,
        2200: 512,
      },
      1200: {
        400: 143,
        500: 154,
        600: 174,
        700: 198,
        800: 222,
        900: 248,
        1000: 271,
        1100: 290,
        1200: 315,
        1300: 335,
        1400: 359,
        1500: 380,
        1600: 404,
        1700: 424,
        1800: 448,
        1900: 468,
        2000: 492,
        2100: 512,
        2200: 538,
      },
      1300: {
        400: 149,
        500: 161,
        600: 182,
        700: 209,
        800: 233,
        900: 258,
        1000: 284,
        1100: 303,
        1200: 330,
        1300: 351,
        1400: 377,
        1500: 398,
        1600: 423,
        1700: 444,
        1800: 471,
        1900: 491,
        2000: 514,
        2100: 536,
        2200: 565,
      },
      1400: {
        400: 156,
        500: 167,
        600: 190,
        700: 217,
        800: 242,
        900: 270,
        1000: 294,
        1100: 315,
        1200: 344,
        1300: 366,
        1400: 394,
        1500: 416,
        1600: 442,
        1700: 465,
        1800: 491,
        1900: 512,
        2000: 539,
        2100: 561,
        2200: 592,
      },
      1500: {
        400: 162,
        500: 174,
        600: 198,
        700: 226,
        800: 253,
        900: 282,
        1000: 307,
        1100: 329,
        1200: 358,
        1300: 382,
        1400: 410,
        1500: 433,
        1600: 462,
        1700: 485,
        1800: 512,
        1900: 536,
        2000: 563,
        2100: 586,
        2200: 618,
      },
      1600: {
        400: 169,
        500: 181,
        600: 207,
        700: 234,
        800: 263,
        900: 291,
        1000: 320,
        1100: 342,
        1200: 374,
        1300: 398,
        1400: 427,
        1500: 451,
        1600: 480,
        1700: 505,
        1800: 534,
        1900: 558,
        2000: 586,
        2100: 611,
        2200: 646,
      },
      1700: {
        400: 175,
        500: 188,
        600: 214,
        700: 244,
        800: 273,
        900: 303,
        1000: 332,
        1100: 356,
        1200: 388,
        1300: 413,
        1400: 443,
        1500: 469,
        1600: 499,
        1700: 525,
        1800: 555,
        1900: 581,
        2000: 610,
        2100: 635,
        2200: 671,
      },
      1800: {
        400: 181,
        500: 195,
        600: 223,
        700: 252,
        800: 283,
        900: 315,
        1000: 344,
        1100: 369,
        1200: 403,
        1300: 430,
        1400: 461,
        1500: 488,
        1600: 518,
        1700: 547,
        1800: 576,
        1900: 603,
        2000: 632,
        2100: 650,
        2200: 699,
      },
      1900: {
        400: 188,
        500: 203,
        600: 230,
        700: 263,
        800: 294,
        900: 325,
        1000: 356,
        1100: 382,
        1200: 417,
        1300: 445,
        1400: 477,
        1500: 505,
        1600: 537,
        1700: 567,
        1800: 598,
        1900: 626,
        2000: 657,
        2100: 685,
        2200: 726,
      },
      2000: {
        400: 194,
        500: 208,
        600: 239,
        700: 271,
        800: 304,
        900: 336,
        1000: 369,
        1100: 395,
        1200: 430,
        1300: 461,
        1400: 494,
        1500: 524,
        1600: 555,
        1700: 586,
        1800: 619,
        1900: 649,
        2000: 680,
        2100: 710,
        2200: 752,
      },
      2100: {
        400: 201,
        500: 216,
        600: 247,
        700: 280,
        800: 314,
        900: 348,
        1000: 381,
        1100: 408,
        1200: 445,
        1300: 477,
        1400: 510,
        1500: 542,
        1600: 575,
        1700: 608,
        1800: 640,
        1900: 672,
        2000: 704,
        2100: 736,
        2200: 779,
      },
      2200: {
        400: 207,
        500: 223,
        600: 255,
        700: 290,
        800: 325,
        900: 358,
        1000: 392,
        1100: 421,
        1200: 460,
        1300: 492,
        1400: 527,
        1500: 559,
        1600: 594,
        1700: 627,
        1800: 660,
        1900: 694,
        2000: 727,
        2100: 760,
        2200: 806,
      },
      2300: {
        400: 213,
        500: 228,
        600: 263,
        700: 298,
        800: 334,
        900: 370,
        1000: 405,
        1100: 435,
        1200: 474,
        1300: 509,
        1400: 543,
        1500: 578,
        1600: 613,
        1700: 647,
        1800: 683,
        1900: 717,
        2000: 752,
        2100: 785,
        2200: 832,
      },
      2400: {
        400: 220,
        500: 237,
        600: 272,
        700: 309,
        800: 345,
        900: 382,
        1000: 417,
        1100: 448,
        1200: 489,
        1300: 524,
        1400: 561,
        1500: 596,
        1600: 632,
        1700: 667,
        1800: 704,
        1900: 739,
        2000: 775,
        2100: 810,
        2200: 859,
      },
      2500: {
        400: 225,
        500: 243,
        600: 279,
        700: 317,
        800: 354,
        900: 393,
        1000: 430,
        1100: 463,
        1200: 503,
        1300: 539,
        1400: 578,
        1500: 614,
        1600: 651,
        1700: 687,
        1800: 725,
        1900: 763,
        2000: 799,
        2100: 835,
        2200: 886,
      },
      2600: {
        400: 233,
        500: 251,
        600: 288,
        700: 327,
        800: 365,
        900: 403,
        1000: 441,
        1100: 474,
        1200: 519,
        1300: 556,
        1400: 594,
        1500: 631,
        1600: 670,
        1700: 708,
        1800: 747,
        1900: 785,
        2000: 822,
        2100: 860,
        2200: 912,
      },
      2700: {
        400: 238,
        500: 257,
        600: 295,
        700: 335,
        800: 376,
        900: 415,
        1000: 454,
        1100: 487,
        1200: 533,
        1300: 571,
        1400: 611,
        1500: 649,
        1600: 690,
        1700: 728,
        1800: 768,
        1900: 806,
        2000: 846,
        2100: 884,
        2200: 939,
      },
      2800: {
        400: 244,
        500: 263,
        600: 305,
        700: 344,
        800: 385,
        900: 427,
        1000: 465,
        1100: 501,
        1200: 547,
        1300: 588,
        1400: 627,
        1500: 667,
        1600: 709,
        1700: 748,
        1800: 789,
        1900: 830,
        2000: 870,
        2100: 909,
        2200: 966,
      },
    },
    3: {
      700: {
        400: 124,
        500: 133,
        600: 152,
        700: 172,
        800: 187,
        900: 218,
        1000: 229,
        1100: 250,
        1200: 271,
        1300: 290,
        1400: 310,
        1500: 329,
        1600: 350,
        1700: 370,
        1800: 389,
        1900: 402,
        2000: 420,
        2100: 441,
        2200: 466,
      },
      800: {
        400: 128,
        500: 139,
        600: 160,
        700: 179,
        800: 195,
        900: 226,
        1000: 240,
        1100: 260,
        1200: 280,
        1300: 301,
        1400: 322,
        1500: 342,
        1600: 362,
        1700: 384,
        1800: 405,
        1900: 418,
        2000: 438,
        2100: 460,
        2200: 485,
      },
      900: {
        400: 136,
        500: 146,
        600: 168,
        700: 190,
        800: 207,
        900: 239,
        1000: 255,
        1100: 276,
        1200: 299,
        1300: 320,
        1400: 343,
        1500: 365,
        1600: 387,
        1700: 409,
        1800: 430,
        1900: 446,
        2000: 467,
        2100: 489,
        2200: 517,
      },
      1000: {
        400: 143,
        500: 155,
        600: 178,
        700: 201,
        800: 220,
        900: 253,
        1000: 271,
        1100: 293,
        1200: 317,
        1300: 341,
        1400: 364,
        1500: 387,
        1600: 409,
        1700: 435,
        1800: 458,
        1900: 475,
        2000: 497,
        2100: 520,
        2200: 550,
      },
      1100: {
        400: 151,
        500: 162,
        600: 187,
        700: 213,
        800: 233,
        900: 266,
        1000: 286,
        1100: 309,
        1200: 336,
        1300: 360,
        1400: 384,
        1500: 410,
        1600: 434,
        1700: 458,
        1800: 485,
        1900: 503,
        2000: 527,
        2100: 552,
        2200: 582,
      },
      1200: {
        400: 158,
        500: 171,
        600: 197,
        700: 225,
        800: 245,
        900: 281,
        1000: 301,
        1100: 326,
        1200: 355,
        1300: 379,
        1400: 404,
        1500: 432,
        1600: 457,
        1700: 484,
        1800: 511,
        1900: 531,
        2000: 557,
        2100: 582,
        2200: 614,
      },
      1300: {
        400: 165,
        500: 179,
        600: 208,
        700: 234,
        800: 256,
        900: 292,
        1000: 317,
        1100: 342,
        1200: 372,
        1300: 399,
        1400: 427,
        1500: 453,
        1600: 481,
        1700: 509,
        1800: 538,
        1900: 560,
        2000: 586,
        2100: 613,
        2200: 647,
      },
      1400: {
        400: 172,
        500: 187,
        600: 216,
        700: 246,
        800: 269,
        900: 307,
        1000: 332,
        1100: 359,
        1200: 390,
        1300: 418,
        1400: 447,
        1500: 477,
        1600: 505,
        1700: 535,
        1800: 565,
        1900: 588,
        2000: 616,
        2100: 645,
        2200: 679,
      },
      1500: {
        400: 179,
        500: 195,
        600: 227,
        700: 258,
        800: 282,
        900: 321,
        1000: 346,
        1100: 375,
        1200: 409,
        1300: 439,
        1400: 467,
        1500: 498,
        1600: 528,
        1700: 558,
        1800: 590,
        1900: 616,
        2000: 645,
        2100: 676,
        2200: 710,
      },
      1600: {
        400: 188,
        500: 204,
        600: 235,
        700: 269,
        800: 295,
        900: 334,
        1000: 360,
        1100: 392,
        1200: 427,
        1300: 458,
        1400: 489,
        1500: 521,
        1600: 552,
        1700: 584,
        1800: 617,
        1900: 643,
        2000: 676,
        2100: 705,
        2200: 743,
      },
      1700: {
        400: 195,
        500: 211,
        600: 246,
        700: 279,
        800: 307,
        900: 348,
        1000: 376,
        1100: 408,
        1200: 445,
        1300: 477,
        1400: 509,
        1500: 544,
        1600: 575,
        1700: 610,
        1800: 643,
        1900: 672,
        2000: 706,
        2100: 738,
        2200: 775,
      },
      1800: {
        400: 203,
        500: 220,
        600: 255,
        700: 291,
        800: 320,
        900: 361,
        1000: 391,
        1100: 425,
        1200: 463,
        1300: 497,
        1400: 529,
        1500: 565,
        1600: 599,
        1700: 635,
        1800: 670,
        1900: 700,
        2000: 735,
        2100: 769,
        2200: 807,
      },
      1900: {
        400: 210,
        500: 227,
        600: 265,
        700: 302,
        800: 333,
        900: 374,
        1000: 406,
        1100: 441,
        1200: 482,
        1300: 516,
        1400: 551,
        1500: 589,
        1600: 621,
        1700: 660,
        1800: 697,
        1900: 728,
        2000: 766,
        2100: 798,
        2200: 840,
      },
      2000: {
        400: 218,
        500: 236,
        600: 275,
        700: 314,
        800: 346,
        900: 387,
        1000: 422,
        1100: 458,
        1200: 501,
        1300: 536,
        1400: 572,
        1500: 610,
        1600: 646,
        1700: 685,
        1800: 723,
        1900: 757,
        2000: 794,
        2100: 830,
        2200: 872,
      },
      2100: {
        400: 225,
        500: 244,
        600: 283,
        700: 325,
        800: 359,
        900: 401,
        1000: 437,
        1100: 474,
        1200: 519,
        1300: 556,
        1400: 592,
        1500: 633,
        1600: 670,
        1700: 711,
        1800: 750,
        1900: 785,
        2000: 824,
        2100: 861,
        2200: 904,
      },
      2200: {
        400: 234,
        500: 252,
        600: 294,
        700: 335,
        800: 371,
        900: 415,
        1000: 452,
        1100: 491,
        1200: 536,
        1300: 575,
        1400: 613,
        1500: 655,
        1600: 693,
        1700: 735,
        1800: 777,
        1900: 813,
        2000: 854,
        2100: 891,
        2200: 937,
      },
      2300: {
        400: 241,
        500: 260,
        600: 303,
        700: 347,
        800: 384,
        900: 428,
        1000: 468,
        1100: 507,
        1200: 555,
        1300: 594,
        1400: 634,
        1500: 677,
        1600: 717,
        1700: 760,
        1800: 803,
        1900: 840,
        2000: 884,
        2100: 923,
        2200: 969,
      },
      2400: {
        400: 249,
        500: 269,
        600: 313,
        700: 358,
        800: 397,
        900: 442,
        1000: 483,
        1100: 524,
        1200: 573,
        1300: 615,
        1400: 656,
        1500: 699,
        1600: 741,
        1700: 785,
        1800: 830,
        1900: 869,
        2000: 913,
        2100: 954,
        2200: 1001,
      },
      2500: {
        400: 255,
        500: 276,
        600: 324,
        700: 369,
        800: 410,
        900: 454,
        1000: 498,
        1100: 540,
        1200: 591,
        1300: 634,
        1400: 676,
        1500: 722,
        1600: 764,
        1700: 811,
        1800: 857,
        1900: 898,
        2000: 944,
        2100: 985,
        2200: 1034,
      },
      2600: {
        400: 262,
        500: 285,
        600: 332,
        700: 380,
        800: 423,
        900: 468,
        1000: 514,
        1100: 557,
        1200: 609,
        1300: 654,
        1400: 696,
        1500: 745,
        1600: 788,
        1700: 836,
        1800: 883,
        1900: 927,
        2000: 972,
        2100: 1016,
        2200: 1065,
      },
      2700: {
        400: 270,
        500: 292,
        600: 342,
        700: 391,
        800: 434,
        900: 481,
        1000: 529,
        1100: 573,
        1200: 628,
        1300: 673,
        1400: 718,
        1500: 767,
        1600: 811,
        1700: 860,
        1800: 911,
        1900: 954,
        2000: 1002,
        2100: 1047,
        2200: 1097,
      },
      2800: {
        400: 277,
        500: 302,
        600: 352,
        700: 403,
        800: 447,
        900: 495,
        1000: 544,
        1100: 590,
        1200: 646,
        1300: 691,
        1400: 738,
        1500: 789,
        1600: 835,
        1700: 885,
        1800: 936,
        1900: 982,
        2000: 1032,
        2100: 1078,
        2200: 1130,
      },
    },
    4: {
      700: {
        400: 141,
        500: 151,
        600: 173,
        700: 195,
        800: 211,
        900: 247,
        1000: 261,
        1100: 283,
        1200: 306,
        1300: 328,
        1400: 350,
        1500: 372,
        1600: 396,
        1700: 418,
        1800: 440,
        1900: 453,
        2000: 474,
        2100: 498,
        2200: 527,
      },
      800: {
        400: 145,
        500: 157,
        600: 181,
        700: 203,
        800: 221,
        900: 256,
        1000: 272,
        1100: 294,
        1200: 317,
        1300: 340,
        1400: 364,
        1500: 387,
        1600: 409,
        1700: 434,
        1800: 457,
        1900: 472,
        2000: 495,
        2100: 519,
        2200: 548,
      },
      900: {
        400: 154,
        500: 166,
        600: 190,
        700: 215,
        800: 234,
        900: 271,
        1000: 289,
        1100: 313,
        1200: 339,
        1300: 362,
        1400: 388,
        1500: 413,
        1600: 438,
        1700: 462,
        1800: 487,
        1900: 505,
        2000: 529,
        2100: 553,
        2200: 585,
      },
      1000: {
        400: 163,
        500: 176,
        600: 202,
        700: 229,
        800: 249,
        900: 287,
        1000: 307,
        1100: 332,
        1200: 359,
        1300: 387,
        1400: 413,
        1500: 439,
        1600: 463,
        1700: 492,
        1800: 518,
        1900: 538,
        2000: 563,
        2100: 589,
        2200: 623,
      },
      1100: {
        400: 172,
        500: 185,
        600: 212,
        700: 242,
        800: 264,
        900: 302,
        1000: 325,
        1100: 351,
        1200: 381,
        1300: 408,
        1400: 436,
        1500: 465,
        1600: 492,
        1700: 519,
        1800: 549,
        1900: 570,
        2000: 598,
        2100: 625,
        2200: 659,
      },
      1200: {
        400: 180,
        500: 194,
        600: 224,
        700: 256,
        800: 278,
        900: 319,
        1000: 342,
        1100: 370,
        1200: 403,
        1300: 430,
        1400: 459,
        1500: 490,
        1600: 519,
        1700: 549,
        1800: 579,
        1900: 603,
        2000: 632,
        2100: 661,
        2200: 696,
      },
      1300: {
        400: 188,
        500: 204,
        600: 236,
        700: 267,
        800: 291,
        900: 332,
        1000: 360,
        1100: 389,
        1200: 423,
        1300: 453,
        1400: 485,
        1500: 515,
        1600: 546,
        1700: 578,
        1800: 611,
        1900: 635,
        2000: 666,
        2100: 696,
        2200: 734,
      },
      1400: {
        400: 196,
        500: 213,
        600: 246,
        700: 280,
        800: 306,
        900: 351,
        1000: 378,
        1100: 408,
        1200: 443,
        1300: 475,
        1400: 508,
        1500: 542,
        1600: 573,
        1700: 608,
        1800: 642,
        1900: 668,
        2000: 700,
        2100: 732,
        2200: 771,
      },
      1500: {
        400: 205,
        500: 223,
        600: 258,
        700: 294,
        800: 321,
        900: 365,
        1000: 394,
        1100: 427,
        1200: 465,
        1300: 499,
        1400: 531,
        1500: 566,
        1600: 600,
        1700: 635,
        1800: 670,
        1900: 700,
        2000: 734,
        2100: 768,
        2200: 807,
      },
      1600: {
        400: 214,
        500: 232,
        600: 268,
        700: 306,
        800: 336,
        900: 380,
        1000: 410,
        1100: 446,
        1200: 485,
        1300: 521,
        1400: 556,
        1500: 592,
        1600: 628,
        1700: 664,
        1800: 701,
        1900: 732,
        2000: 769,
        2100: 803,
        2200: 845,
      },
      1700: {
        400: 222,
        500: 240,
        600: 280,
        700: 318,
        800: 350,
        900: 396,
        1000: 428,
        1100: 465,
        1200: 507,
        1300: 543,
        1400: 580,
        1500: 619,
        1600: 655,
        1700: 694,
        1800: 731,
        1900: 764,
        2000: 803,
        2100: 840,
        2200: 882,
      },
      1800: {
        400: 232,
        500: 251,
        600: 291,
        700: 332,
        800: 364,
        900: 411,
        1000: 445,
        1100: 484,
        1200: 527,
        1300: 566,
        1400: 603,
        1500: 644,
        1600: 682,
        1700: 723,
        1800: 762,
        1900: 797,
        2000: 837,
        2100: 875,
        2200: 919,
      },
      1900: {
        400: 240,
        500: 259,
        600: 302,
        700: 344,
        800: 379,
        900: 426,
        1000: 463,
        1100: 503,
        1200: 549,
        1300: 587,
        1400: 627,
        1500: 671,
        1600: 708,
        1700: 751,
        1800: 794,
        1900: 829,
        2000: 872,
        2100: 909,
        2200: 957,
      },
      2000: {
        400: 249,
        500: 269,
        600: 314,
        700: 357,
        800: 394,
        900: 441,
        1000: 481,
        1100: 522,
        1200: 571,
        1300: 610,
        1400: 651,
        1500: 695,
        1600: 736,
        1700: 780,
        1800: 823,
        1900: 862,
        2000: 904,
        2100: 945,
        2200: 993,
      },
      2100: {
        400: 258,
        500: 278,
        600: 323,
        700: 371,
        800: 409,
        900: 457,
        1000: 498,
        1100: 541,
        1200: 591,
        1300: 633,
        1400: 674,
        1500: 721,
        1600: 763,
        1700: 810,
        1800: 855,
        1900: 894,
        2000: 938,
        2100: 981,
        2200: 1030,
      },
      2200: {
        400: 267,
        500: 288,
        600: 335,
        700: 382,
        800: 423,
        900: 473,
        1000: 516,
        1100: 560,
        1200: 612,
        1300: 655,
        1400: 699,
        1500: 747,
        1600: 790,
        1700: 838,
        1800: 886,
        1900: 927,
        2000: 974,
        2100: 1016,
        2200: 1068,
      },
      2300: {
        400: 275,
        500: 297,
        600: 346,
        700: 395,
        800: 438,
        900: 488,
        1000: 534,
        1100: 579,
        1200: 633,
        1300: 677,
        1400: 723,
        1500: 772,
        1600: 817,
        1700: 867,
        1800: 916,
        1900: 958,
        2000: 1008,
        2100: 1053,
        2200: 1104,
      },
      2400: {
        400: 285,
        500: 307,
        600: 357,
        700: 409,
        800: 453,
        900: 504,
        1000: 551,
        1100: 596,
        1200: 654,
        1300: 701,
        1400: 748,
        1500: 797,
        1600: 845,
        1700: 895,
        1800: 947,
        1900: 991,
        2000: 1041,
        2100: 1088,
        2200: 1141,
      },
      2500: {
        400: 291,
        500: 315,
        600: 369,
        700: 421,
        800: 468,
        900: 518,
        1000: 569,
        1100: 617,
        1200: 674,
        1300: 723,
        1400: 771,
        1500: 824,
        1600: 872,
        1700: 925,
        1800: 978,
        1900: 1025,
        2000: 1077,
        2100: 1123,
        2200: 1179,
      },
      2600: {
        400: 300,
        500: 326,
        600: 379,
        700: 433,
        800: 482,
        900: 534,
        1000: 587,
        1100: 636,
        1200: 696,
        1300: 746,
        1400: 794,
        1500: 850,
        1600: 899,
        1700: 953,
        1800: 1008,
        1900: 1057,
        2000: 1109,
        2100: 1160,
        2200: 1216,
      },
      2700: {
        400: 309,
        500: 334,
        600: 391,
        700: 447,
        800: 496,
        900: 549,
        1000: 604,
        1100: 655,
        1200: 717,
        1300: 768,
        1400: 820,
        1500: 876,
        1600: 926,
        1700: 982,
        1800: 1039,
        1900: 1089,
        2000: 1143,
        2100: 1195,
        2200: 1252,
      },
      2800: {
        400: 317,
        500: 345,
        600: 402,
        700: 460,
        800: 511,
        900: 566,
        1000: 622,
        1100: 674,
        1200: 738,
        1300: 789,
        1400: 843,
        1500: 901,
        1600: 953,
        1700: 1012,
        1800: 1069,
        1900: 1121,
        2000: 1178,
        2100: 1230,
        2200: 1290,
      },
    },
  },
};

document.addEventListener("DOMContentLoaded", function () {
  const config = window.PremiumProductConfig;
  let selectedFabricGroup = null;
  let selectedProfile = null;
  let widthInput, heightInput, profileStep, priceDisplay, calculatedPrice;

  // Piilota alkuperäinen ostoskoriin-nappi heti
  setTimeout(function () {
    const originalButton = document.querySelector('button[name="add"]');

    if (originalButton) {
      originalButton.style.position = "absolute";
      originalButton.style.left = "-9999px";
      originalButton.style.visibility = "hidden";
      console.log("Original button hidden on page load");
    }
  }, 100);

  // Odota että DOM on valmis, sitten luo elementit
  setTimeout(function () {
    console.log("Calling createPremiumElements...");
    createPremiumElements();

    // Tunnista oletuskangasväri sivun latautuessa
    const fabricSelect = document.querySelector(
      'select[name="options[KANGAS]"]'
    );
    if (fabricSelect && fabricSelect.selectedIndex >= 0) {
      const selectedOption = fabricSelect.options[fabricSelect.selectedIndex];
      const variantTitle = selectedOption.text;
      const groupMatch = variantTitle.match(/\(([^)]+)\)[^(]*$/);
      if (groupMatch) {
        selectedFabricGroup = groupMatch[1];
        console.log("Initial fabric group detected:", selectedFabricGroup);

        if (profileStep) {
          profileStep.classList.remove("disabled");
          profileStep.classList.add("active");
          createProfileOptions();
        }
      }
    }

    // Kangasvärin valinta
    if (fabricSelect) {
      fabricSelect.addEventListener("change", function () {
        const selectedOption = this.options[this.selectedIndex];
        const variantTitle = selectedOption.text;

        const groupMatch = variantTitle.match(/\(([^)]+)\)[^(]*$/);
        if (groupMatch) {
          selectedFabricGroup = groupMatch[1];
          console.log("Selected fabric group:", selectedFabricGroup);

          if (profileStep) {
            profileStep.classList.remove("disabled");
            profileStep.classList.add("active");
            createProfileOptions();
          }
          calculatePrice();
        }
      });
    }
  }, 300);

  function createPremiumElements() {
  const productForm =
    document.querySelector(".product-form") ||
    document.querySelector(".product__info-wrapper") ||
    document.body;

  // Luo pääkontaineri
  let configurator = document.getElementById("premium-configurator");
  if (!configurator) {
    configurator = document.createElement("div");
    configurator.id = "premium-configurator";
    configurator.className = "slim-configurator";
    productForm.appendChild(configurator);
  }

    // Luo mittakentät
    if (!document.getElementById("width-input")) {
      const dimensionsDiv = document.createElement("div");
      dimensionsDiv.className = "config-step active";

      dimensionsDiv.innerHTML = `
            <h3>Syötä mitat (mm)</h3>
            <div class="dimension-inputs">
                <div class="input-group">
                    <label>Leveys</label>
                    <input placeholder="esim. 700" max="1500" min="200" id="width-input" type="number">
                    <div id="width-validation" class="validation-message"></div>
                </div>
                <div class="input-group">
                    <label>Korkeus</label>
                    <input placeholder="esim. 1200" max="2500" min="200" id="height-input" type="number">
                    <div id="height-validation" class="validation-message"></div>
                </div>
            </div>
        `;

      configurator.appendChild(dimensionsDiv);
    }

    // Luo profiiliväri-osio
    if (!document.getElementById("profile-step")) {
      const profileDiv = document.createElement("div");
      profileDiv.id = "profile-step";
      profileDiv.className = "config-step disabled";
      profileDiv.innerHTML = `
            <h3>Valitse profiiliväri</h3>
            <div id="profile-options"></div>
        `;
      configurator.appendChild(profileDiv);
    }

    // Luo hinta-osio
    if (!document.getElementById("price-display")) {
      const priceDiv = document.createElement("div");
      priceDiv.id = "price-display";
      priceDiv.className = "config-step price-display";
      priceDiv.style.display = "none";
      priceDiv.innerHTML = `
            <h3>Hinta</h3>
            <div style="font-size: 2rem; font-weight: bold; color: #ffffff; margin-bottom: 15px;" id="calculated-price"></div>
        `;
      configurator.appendChild(priceDiv);
    }

    // Päivitä elementtiviittaukset
    widthInput = document.getElementById("width-input");
    heightInput = document.getElementById("height-input");
    profileStep = document.getElementById("profile-step");
    priceDisplay = document.getElementById("price-display");
    calculatedPrice = document.getElementById("calculated-price");
  }

  function getProfilesForProduct() {
    const productHandle = window.location.pathname;

    // Jos ALL-BLACK tai MUSTA tuote - vain musta profiili
    if (
      productHandle.includes("all-black") ||
      productHandle.includes("musta")
    ) {
      return {
        anthracite: {
          name: "Musta RAL9005 structure",
          color: "#0A0A0A",
        },
      };
    }

    // Muuten kaikki normaalit BASIC profiilit
    return config.profiles;
  }

  function createProfileOptions() {
    const profileOptions = document.getElementById("profile-options");
    if (!profileOptions) return;

    const customDropdown = document.createElement("div");
    customDropdown.className = "custom-dropdown";

    const selected = document.createElement("div");
    selected.className = "dropdown-selected";

    selected.innerHTML = `
    <span>Valitse profiiliväri</span>
    <span class="dropdown-arrow">▼</span>
`;

    const options = document.createElement("div");
    options.className = "dropdown-options";

    // Lisää profiilivärit
    Object.keys(getProfilesForProduct()).forEach(function (key) {
      const profile = getProfilesForProduct()[key];

      const option = document.createElement("div");
      option.className = "dropdown-option";

      option.innerHTML = `
    <span class="profile-color-icon" style="background-color: ${profile.color};"></span>
    <span class="profile-option-text">${profile.name}</span>
  `;

      option.addEventListener("click", function () {
        selectedProfile = key;
        selected.innerHTML = `
      <span class="dropdown-selected-content">
        <span class="profile-color-icon" style="background-color: ${profile.color};"></span>
        ${profile.name}
      </span>
      <span class="dropdown-arrow">▼</span>
    `;

        options.classList.remove("show");
        calculatePrice();
      });

      options.appendChild(option);
    });

    selected.addEventListener("click", function () {
      options.classList.toggle("show");
    });

    customDropdown.appendChild(selected);
    customDropdown.appendChild(options);

    profileOptions.innerHTML = "";
    profileOptions.appendChild(customDropdown);
  }

  function calculatePrice() {
    console.log("calculatePrice called");
    const width = parseInt(widthInput?.value) || 0;
    const height = parseInt(heightInput?.value) || 0;

    // Tarkista validointi ensin
    if (!updateFieldValidation()) {
      console.log("Validation failed");
      // Näytä lähtöhinta vaikka validointi epäonnistui (Google-vaatimus)
      if (priceDisplay) priceDisplay.style.display = "block";
      if (calculatedPrice) calculatedPrice.textContent = "Alkaen 130.00 €";
      return;
    }

    // Tarkista että profiiliväri on valittu
    if (!selectedProfile) {
      console.log("No profile selected");
      // Näytä lähtöhinta vaikka profiilia ei valittu (Google-vaatimus)
      if (priceDisplay) priceDisplay.style.display = "block";
      if (calculatedPrice) calculatedPrice.textContent = "Alkaen 130.00 €";
      return;
    }

    console.log("Current values:", {
      width: width,
      height: height,
      selectedFabricGroup: selectedFabricGroup,
      selectedProfile: selectedProfile,
    });

    if (
      width > 0 &&
      height > 0 &&
      selectedFabricGroup &&
      config.priceTable[selectedFabricGroup]
    ) {
      const normalizedWidth = Math.min(
        Math.max(Math.ceil(width / 100) * 100, 400),
        1400
      );
      const normalizedHeight = Math.min(
        Math.max(Math.ceil(height / 100) * 100, 700),
        2400
      );

      console.log(
        "Normalized dimensions:",
        normalizedWidth,
        "x",
        normalizedHeight
      );

      const priceData = config.priceTable[selectedFabricGroup];
      let basePrice = null;

      if (priceData[normalizedHeight]) {
        if (priceData[normalizedHeight][normalizedWidth]) {
          basePrice = priceData[normalizedHeight][normalizedWidth];
          console.log("Price found:", basePrice);
        } else {
          // B-hinnoittelu: etsi lähin pienempi leveys
          for (let w = normalizedWidth - 100; w >= 400; w -= 100) {
            if (priceData[normalizedHeight][w]) {
              basePrice = priceData[normalizedHeight][w];
              console.log("B-pricing: Found price", basePrice, "at width", w);
              break;
            }
          }
          if (!basePrice) basePrice = 130.0;
        }
      } else {
        // B-hinnoittelu: etsi lähin pienempi korkeus
        for (let h = normalizedHeight - 100; h >= 700; h -= 100) {
          if (priceData[h] && priceData[h][normalizedWidth]) {
            basePrice = priceData[h][normalizedWidth];
            console.log("B-pricing: Found price", basePrice, "at height", h);
            break;
          }
        }
        if (!basePrice) basePrice = 130.0;
      }

      if (calculatedPrice && basePrice) {
        // 1. Lisää euromääräinen muutos
        let priceAfterEuro = basePrice + PRICE_ADJUSTMENTS.euroAdjustment;
        console.log("After euro adjustment:", priceAfterEuro);
        
        // 2. Lisää prosentuaalinen muutos
        let priceAfterPercent = priceAfterEuro * (1 + PRICE_ADJUSTMENTS.percentAdjustment / 100);
        console.log("After percent adjustment:", priceAfterPercent);
        
        // 3. Pyöristä lähimpään tasaeuroon
        let roundedPrice = Math.round(priceAfterPercent);
        console.log("After rounding:", roundedPrice);
        
        // 4. Varmista minimihinta 130 €
        const finalPrice = Math.max(roundedPrice, 130);
        console.log("Final price:", finalPrice);
        
        calculatedPrice.textContent = finalPrice.toFixed(2) + " €";
      }
      if (priceDisplay) {
        priceDisplay.style.display = "block";
      }

      // Lisää ostoskoriin-nappi
      createAddToCartButton();
    } else {
      console.log("Conditions not met for price calculation");
      if (priceDisplay) priceDisplay.style.display = "none";
    }
  }

  function validateDimensions(width, height) {
    const errors = {};
    const messages = {};

    if (width < 200) {
      errors.width = true;
      messages.width = "Min 200mm";
    } else if (width > 1500) {
      errors.width = true;
      messages.width = "Max 1500 mm\nLeveämmät koot saatavilla,\nota yhteyttä.";
    }

    if (height < 200) {
      errors.height = true;
      messages.height = "Min 200mm";
    } else if (height > 2500) {
      errors.height = true;
      messages.height = "Max 2500mm";
    }

    if (width * height > 2600000) {
      errors.width = true;
      errors.height = true;
      messages.width = "Max 2,6 m²";
      messages.height = "Max 2,6 m²";
    }

    if (width >= 801 && width <= 1200 && height > 2200) {
      errors.height = true;
      messages.height = "Max 2200mm";
    }
    if (width >= 1201 && width <= 1500 && height > 1600) {
      errors.height = true;
      messages.height = "Max 1600mm";
    }

    return { errors, messages };
  }

  function updateFieldValidation() {
    const width = parseInt(widthInput?.value) || 0;
    const height = parseInt(heightInput?.value) || 0;

    if (width > 0 && height > 0) {
      const validation = validateDimensions(width, height);

      // Käytä CSS-luokkia inline-tyylien sijaan
      const widthValidation = document.getElementById("width-validation");
      const heightValidation = document.getElementById("height-validation");

      if (validation.errors.width) {
        widthInput.style.borderColor = "#ff6b6b";
        if (widthValidation) {
          widthValidation.textContent = validation.messages.width;
          widthValidation.className = "validation-message error";
        }
      } else {
        widthInput.style.borderColor = "#333";
        if (widthValidation) {
          widthValidation.textContent = "";
          widthValidation.className = "validation-message";
        }
      }

      if (validation.errors.height) {
        heightInput.style.borderColor = "#ff6b6b";
        if (heightValidation) {
          heightValidation.textContent = validation.messages.height;
          heightValidation.className = "validation-message error";
        }
      } else {
        heightInput.style.borderColor = "#333";
        if (heightValidation) {
          heightValidation.textContent = "";
          heightValidation.className = "validation-message";
        }
      }

      if (validation.errors.width || validation.errors.height) {
        if (priceDisplay) priceDisplay.style.display = "none";
        return false;
      }
    }

    return true;
  }

  function createAddToCartButton() {
  // Tarkista onko nappi jo olemassa
  let existingButton = document.getElementById("premium-add-to-cart");
  if (existingButton) {
    existingButton.style.display = "block";
    return;
  }

  // Luo uusi nappi
  const addToCartButton = document.createElement("button");
  addToCartButton.id = "premium-add-to-cart";
  addToCartButton.type = "button";
  addToCartButton.textContent = "Lisää ostoskoriin";
  addToCartButton.className = "premium-add-to-cart-button";

  // UUSI: Cart API -pohjainen lisäys
  addToCartButton.addEventListener("click", function () {
    // Kerää tiedot
    const width = parseInt(widthInput.value);
    const height = parseInt(heightInput.value);
    const calculatedPriceValue = parseFloat(calculatedPrice.textContent.replace(' €', '').replace(',', '.'));
    const profileName = getProfilesForProduct()[selectedProfile].name;
    
    // Hae kangasväri
    const fabricSelect = document.querySelector('select[name="options[KANGAS]"]');
    const fabricOption = fabricSelect ? fabricSelect.options[fabricSelect.selectedIndex].text : 'Ei valittu';
    
    // Perustuotteen hinta
    const basePrice = 129.00;
    
    // Laske korotus
    const priceAdjustment = calculatedPriceValue - basePrice;
    
    // Luo unique ID tälle tuoteparille
    const pairId = Date.now().toString();
    
    // Valmistele Cart API -kutsu (käänteisessä järjestyksessä)
    const formData = {
      items: []
    };
    
    // Lisää räätälöinti AINA (jos hinta > 0)
    const adjustmentQuantity = Math.max(1, Math.round(priceAdjustment));
    
    formData.items.push({
      id: config.variantIds.adjustment,
      quantity: adjustmentQuantity,
      properties: {
        'Kangasväri': fabricOption,
        'Mitat': `${width}×${height} mm`,
        'Profiiliväri': profileName,
        '_pair_id': pairId,
        '_pair_order': '2'
      }
    });
    
    // Lisää perustuote TOISENA
    formData.items.push({
      id: config.variantIds.base,
      quantity: 1,
      properties: {
        '_pair_id': pairId,
        '_pair_order': '1'
      }
    });
    
    // Lähetä Cart API:lle
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData)
    })
    .then(response => response.json())
    .then(data => {
      console.log('Success:', data);
      // Päivitä ostoskori
      window.location.href = '/cart';
    })
    .catch((error) => {
      console.error('Error:', error);
      alert('Lisääminen ostoskoriin epäonnistui. Yritä uudelleen.');
    });
  });

  // Lisää hinta-osion jälkeen
  if (priceDisplay) {
    priceDisplay.appendChild(addToCartButton);
  }
  
  console.log("Add to cart button created");
}

  // Varmista hinnan päivitys kaikissa tilanteissa
  let lastValues = {
    width: "",
    height: "",
    fabric: "",
    profile: "",
  };

  function checkForChanges() {
    const currentWidth = widthInput?.value || "";
    const currentHeight = heightInput?.value || "";
    const currentFabric =
      document.querySelector('select[name="options[KANGAS]"]')?.value || "";
    const currentProfile = selectedProfile || "";

    if (
      currentWidth !== lastValues.width ||
      currentHeight !== lastValues.height ||
      currentFabric !== lastValues.fabric ||
      currentProfile !== lastValues.profile
    ) {
      console.log("Change detected, updating price...");

      // Päivitä kangasryhmä jos tarpeen
      if (currentFabric !== lastValues.fabric) {
        const fabricSelect = document.querySelector(
          'select[name="options[KANGAS]"]'
        );
        if (fabricSelect) {
          const selectedOption =
            fabricSelect.options[fabricSelect.selectedIndex];
          const variantTitle = selectedOption.text;
          const groupMatch = variantTitle.match(/\(([^)]+)\)[^(]*$/);
          if (groupMatch) {
            selectedFabricGroup = groupMatch[1];
            console.log("Updated fabric group:", selectedFabricGroup);
          }
        }
      }

      calculatePrice();

      lastValues.width = currentWidth;
      lastValues.height = currentHeight;
      lastValues.fabric = currentFabric;
      lastValues.profile = currentProfile;
    }
  }

  function updateAreaDisplay(width, height) {
    console.log("updateAreaDisplay called with:", width, height);

    const areaValueElement = document.getElementById("area-value");
    const areaDisplayElement = document.getElementById("area-display");

    console.log("Area value element:", areaValueElement);
    console.log("Area display element:", areaDisplayElement);

    if (!areaValueElement) {
      console.log("ERROR: area-value element not found!");
      return;
    }

    if (width > 0 && height > 0) {
      const area = ((width * height) / 1000000).toFixed(2);
      console.log("Calculated area:", area);

      areaValueElement.textContent = area + " m²";
      console.log("Area text updated to:", areaValueElement.textContent);

      // Muuta väri jos ylittää 2,6 m²
      if (parseFloat(area) > 2.6) {
        areaValueElement.style.color = "red";
        console.log("Area color set to red");
      } else {
        areaValueElement.style.color = "#dfa408";
        console.log("Area color set to green");
      }
    } else {
      areaValueElement.textContent = "- m²";
      areaValueElement.style.color = "white";
      console.log("Area reset to default");
    }
  }

  // Tarkista muutokset 500ms välein
  setInterval(checkForChanges, 500);
});
